// Auto-refactored from translations.js on 2026-08-19
// Locale: mt

const mt = {
  wieMoeglich: { question: 'Kif inhu possibbli dan?', answer: 'Erġajna ħsibna l-katina tal-valur.' },
  stigRockWeg: {
    overline: 'STIG ROCK',
    title: 'It-triq STIG ROCK',
    fazit: "Il-katina tal-provvista mqassra telimina l-akbar pożizzjonijiet ta' spejjeż.",
    fazitBigPre: 'Dan jippermetti skont sa',
    fazitBigValue: '80%',
    steps: [ 'Minjiera', 'Ħanut tal-qtugħ', 'Ċertifikazzjoni', 'Klijent finali' ]
  },
  nav: { language: 'Lingwa', contact: 'Kuntatt' },
  hero: {
    overline: 'STIG ROCK — Diamond Solution',
    title: 'Opportunità unika',
    subtitle: "Ibni l-ġid b'mod orjentat lejn il-ġejjieni.",
    description: 'STIG ROCK hija pjattaforma internazzjonali li toffri lin-nies aċċess għal djamanti naturali, tkabbir sostenibbli tal-patrimonju u komunità unika.',
    scroll: 'Skrollja biex tiskopri'
  },
  disclaimer: {
    overline: 'Avviż Legali',
    title: 'Disclaimer',
    paragraphs: [
      "Din il-preżentazzjoni hija għal skopijiet ta' informazzjoni biss u ma tikkostitwixxix parir finanzjarju, ta' investiment jew tat-taxxa.",
      'STIG ROCK mhuwiex prodott finanzjarju, iżda jirreferi għal djamanti naturali bħala assi tanġibbli.',
      "Ma tingħata l-ebda garanzija għal żviluppi fil-valur, profitti jew qligħ. Żviluppi tal-passat mhumiex indikazzjoni ta' riżultati futuri.",
      'Il-kalkoli kollha ppreżentati fir-rigward tal-kummissjonijiet huma biss eżemplari u bl-istess mod ma jikkostitwixxu l-ebda garanzija.'
    ]
  },
  aufgebaut: {
    overline: 'STIG GROUP',
    titleLines: [ 'MIBNI FUQ', 'STRUTTURA' ],
    body: 'STIG Group huwa grupp internazzjonali mibni fuq il-kjarezza, ir-responsabbiltà u l-valur fit-tul. Kull marka, kull proġett u kull sħubija isegwu standard wieħed — mingħajr shortcuts, mingħajr eċċezzjonijiet.',
    stages: [
      {
        brand: 'STIG GROUP',
        titleLines: [ 'MIBNI FUQ', 'STRUTTURA' ],
        body: 'STIG Group huwa grupp internazzjonali mibni fuq il-kjarezza, ir-responsabbiltà u l-valur fit-tul. Kull marka, kull proġett u kull sħubija isegwu standard wieħed — mingħajr shortcuts, mingħajr eċċezzjonijiet.'
      },
      {
        brand: 'STIG ROCK',
        titleLines: [ 'ID-DINJA TAD-', 'DIAMOND ESKLUSSIVI' ],
        body: "STIG ROCK huwa kunċett modern ta' STIG Group li jgħaqqad Diamond ċertifikati mill-GIA ta' kwalità għolja ma' strutturi trasparenti u esperjenza esklussiva għall-klijent. Pjanijiet ta' soluzzjoni ċari, proċessar professjonali u orjentazzjoni internazzjonali."
      },
      {
        brand: 'STIG INTERNATIONAL',
        titleLines: [ "KUMMERĊ TA' DIAMOND", 'INTERNAZZJONALI' ],
        body: "STIG International hija parti minn STIG Group u tispeċjalizza fil-kummerċ internazzjonali ta' Diamond ċertifikati mill-GIA. Fokus fuq il-kwalità, il-fiduċja u strutturi kummerċjali moderni b'sħubijiet globali."
      },
      {
        brand: 'ETHICAL MINES',
        titleLines: [ 'RESPONSABBILTÀ', 'MILL-MINJIERA' ],
        body: 'Ethical Mines tfisser estrazzjoni responsabbli, oriġini traċċabbli u Diamond ħielsa minn kunflitti. Mill-minjiera sas-suq — dokumentazzjoni kompleta għat-trasparenza, l-integrità u r-responsabbiltà fit-tul tul il-katina tal-provvista kollha.'
      }
    ]
  },
  moeglichkeiten: {
    stigLine: 'Djamanti',
    stigDrawback: "Ħażna reali ta' valur",
    overline: 'Opportunitajiet',
    title: 'Opportunitajiet għall-bini tal-ġid',
    subtitle: "Tqabbil ta' modi tradizzjonali.",
    items: [
      {
        tag: 'Trading',
        name: 'Forex jew Kripto',
        drawback: 'spekulattiv ħafna, imprevedibbli, kumpless'
      },
      {
        tag: 'Aktien',
        name: 'Kummerċ fil-borża',
        drawback: "riskju ta' fluttwazzjoni, għarfien meħtieġ, ħela ta' ħin"
      },
      {
        tag: 'Krypto',
        name: 'Kummerċ',
        drawback: 'volatilità, riskju regolatorju, dgħjufija fis-sigurtà'
      }
    ]
  },
  chance: {
    overline: 'Diamond',
    title: 'L-opportunità sottovalutata',
    body: "Id-Diamond ilhom snin fost l-aktar forom ta' investiment stabbli fil-valur u promettenti, iżda s'issa ftit kienu dawk li użaw dan il-potenzjal.",
    callout: "Permezz ta' STIG ROCK, għall-ewwel darba qed niftħu l-aċċess għal kulħadd għal dawn l-opportunitajiet straordinarji."
  },
  wertentwicklung: {
    overline: 'Żvilupp tal-valur 1995 — 2025',
    title: 'Storja dwar il-valur.',
    usd: 'US-Dollar',
    usdValue: '-49%',
    diamond: 'Diamond',
    diamondValue: '+185%',
    note: 'Żvilupp mill-1995 — 2025'
  },
  hauptgruende: {
    overline: 'Raġunijiet ewlenin',
    title: 'Sitt raġunijiet għal Diamond',
    lead: 'Id-Diamond huma assi tanġibbli reali li jeżistu indipendentement mill-muniti u s-sistemi finanzjarji — u żammew il-valur tagħhom għal sekli sħaħ.',
    items: [
      {
        n: '01',
        title: 'Stabbiltà fil-valur kontra l-kriżijiet',
        body: "Garanzija ta' assi tanġibbli. Indipendenti mill-muniti u s-sistemi finanzjarji."
      },
      {
        n: '02',
        title: 'Il-mobbiltà aħħarija',
        body: 'Żgħar, faċli biex taħbihom u tittrasportahom.'
      },
      {
        n: '03',
        title: 'Diversifikazzjoni u skarsezza',
        body: 'Nuqqas fil-provvista u limitazzjoni naturali.'
      },
      { n: '04', title: 'Tkabbir fit-tul', body: '+185% mill-1995.' },
      {
        n: '05',
        title: 'Trasparenza u esklussività',
        body: "L-4 C's bħala garanzija: Carat, Color, Clarity, Cut."
      },
      {
        n: '06',
        title: 'Riżerva tal-familji rjali',
        body: "Anke l-familji rjali jużaw Diamond bħala riżerva ta' ġid."
      }
    ]
  },
  markt: {
    overline: 'Volum tas-suq',
    title: '99 — 108 Mrd. USD',
    sub: 'Volum tal-kummerċ fl-2025',
    forecast: "Previżjoni sa ~2032 / 2034: madwar 140 – 168 Mrd. USD b'tkabbir moderat (~4 – 5 % p.a.).",
    source: 'Sors: Fortune Business Insights'
  },
  innovation: {
    overline: 'Stig International — Innovazzjoni',
    title: 'Innovazzjoni. Għall-ewwel darba mad-dinja kollha.',
    body: 'STIG ROCK hija l-ewwel pjattaforma mad-dinja kollha li tippermetti lin-nies jiġġeneraw dħul passiv fis-suq tad-djamanti, minbarra ż-żieda fil-valur.',
    hq: 'STIG Gemstone FZCO DMCC — DMCC-1007195',
    hqLines: [
      'STIG Gemstone FZCO DMCC',
      'HDS Business Centre, Cluster M',
      'Jumeirah Lakes Towers — Dubai, VAE',
      'Nru tar-reġistru DMCC-1007195'
    ],
    team: [
      { name: 'Patrick Stöger', role: 'CEO — Chief Executive Officer' },
      { name: 'Michael Lang', role: 'COO — Chief Operation Officer' }
    ]
  },
  globalNetwork: {
    overline: 'Dwar il-kumpanija',
    titleLines: [ 'STRUTTURA', 'INTERNAZZJONALI', 'VIŻJONI ĊARA' ],
    body: "STIG ROCK ġiet stabbilita biex tagħmel is-suq tad-djamanti aktar trasparenti, modern u orjentat lejn il-klijent — b'fokus fuq il-fiduċja, is-sigurtà u struttura fit-tul."
  },
  sicherheit: {
    overline: 'Kwalità u Sigurtà',
    title: 'Gemological Institute of America',
    body: "EspertIżi ċertifikata għad-Diamond tiegħek. Il-GIA tevalwa kull ġebla bi preċiżjoni massima u snin twal ta' esperjenza — rapporti ta' valutazzjoni affidabbli għall-kumpanija u l-klijenti tagħna.",
    transparency: "Kull Diamond jissodisfa l-ogħla standards ta' kwalità u jiġi vverifikat u ċertifikat minn organizzazzjonijiet rinomati. Kull ġebla hija unika u tirċievi ċertifikat individwali."
  },
  plaene: {
    overline: 'Solution Pläne (SP)',
    title: 'Innovazzjoni unika tal-prodott',
    sub: "Sitt pjanijiet ta' soluzzjoni gradwati — minn $1K sa $100K+, kull wieħed bi skont dejjem jiżdied fix-xahar u tul it-terminu kollu.",
    recommended: 'Popolari',
    oneYear: 'Sena',
    rowLabels: {
      delivery: 'Ħin tal-kunsinna',
      price: 'Prezz tal-prodott',
      carat: 'Karat',
      monthly: 'Skont (Xahar)',
      totalDiscount: 'Skont (Total)',
      duration: 'Terminu'
    },
    headers: {
      plan: 'Pjan',
      from: 'Minn',
      carat: 'Karat',
      monthly: 'Skont / Xahar',
      total: 'Skont Total',
      duration: 'Terminu'
    },
    duration: '1 Sena',
    footnote: 'L-informazzjoni kollha dwar il-prezzijiet hija mingħajr garanzija u tiddependi mill-kwalità, id-domanda u l-iżvilupp attwali tas-suq. Il-pjanijiet Solution huma possibbli wkoll għal sentejn.'
  },
  plaeneVIP: {
    overline: 'Solution Pläne + Pakkett VIP',
    title: 'Aktar Benefiċċji bil-VIP-Paket',
    sub: "Ikkombina s-Solution Plan tiegħek ma' VIP-Paket u ibbenefika minn vantaġġi addizzjonali fil-prezz sa 3%. B'hekk iżżid l-iskont totali tiegħek u tikseb kundizzjonijiet saħansitra aktar attraenti.",
    rowLabels: {
      delivery: 'Ħin tal-kunsinna',
      price: 'Prezz tal-prodott',
      carat: 'Karat',
      monthly: 'Skont (Xahar)',
      totalDiscount: 'Skont (Total)',
      vip1: 'Pakkett VIP 1 (+1%)',
      vip2: 'Pakkett VIP 2 (+2%)',
      vip3: 'Pakkett VIP 3 (+3%)'
    },
    footnote: 'L-informazzjoni kollha dwar il-prezzijiet hija mingħajr garanzija u tiddependi mill-kwalità, id-domanda u l-iżvilupp attwali tas-suq.'
  },
  moeglichkeitenNach: {
    overline: 'STIG ROCK',
    title: 'Aktar Benefiċċji bil-VIP-Paket',
    sub: "Ikkombina s-Solution Plan tiegħek ma' VIP-Paket u ibbenefika minn vantaġġi addizzjonali fil-prezz sa 3%. B'hekk iżżid l-iskont totali tiegħek u tikseb kundizzjonijiet saħansitra aktar attraenti.",
    options: [
      {
        key: 'deliver',
        title: 'Aktar Benefiċċji bil-VIP-Paket',
        body: 'Diamond (Karat) għall-prezz tad-DS-Plan tiegħek*'
      },
      {
        key: 'sellToUs',
        title: 'Biegħ lilna',
        body: "Tista' tbigħ id-Diamond tiegħek lura lilna għall-prezz tax-xiri li ħallast."
      },
      {
        key: 'sellThirdParty',
        title: 'Biegħ lil terzi',
        body: "Tista' tbigħ id-Diamond tiegħek lil partijiet terzi."
      }
    ],
    footnote: '*DS-Plan tirrappreżenta Solution Plan.'
  },
  tradWeg: {
    overline: 'Kummerċ tradizzjonali',
    title: 'It-triq tradizzjonali',
    sub: 'Qabel ma djamant jilħaq il-klijent finali, jinħolqu marġini kummerċjali sinifikanti permezz tal-kummerċ intermedju, bl-ingrossa u bl-imnut, meta mqabbel mal-prezz tad-djamant mhux maħdum mill-minjiera.',
    steps: [
      { title: 'Minjiera', subtitle: 'Diamond mhux maħduma' },
      { title: 'Negozjant intermedju', subtitle: "Xiri ta' Diamond mhux maħduma" },
      { title: 'Illustrar', subtitle: "Qtugħ f'djamanti tal-ġojjellerija" },
      { title: 'Ċertifikazzjoni', subtitle: 'minn istituti rikonoxxuti bħall-GIA' },
      { title: 'Borża tad-Diamond', subtitle: 'Bejgħ lill-bejgħ bl-ingrossa' },
      { title: 'Bejgħ bl-ingrossa', subtitle: 'Bejgħ lill-bejgħ bl-imnut' },
      { title: 'Bejgħ bl-imnut', subtitle: 'eż. ġojjelliera' },
      { title: 'Klijenti finali', subtitle: "Xiri ta' Diamond" }
    ]
  },
  stigWeg: {
    overline: 'STIG INTERNATIONAL GEMSTONE FZCO',
    title: 'The Dual-Purchase System',
    sub: 'One purchase. Two diamonds. Double value creation.',
    duration: '1 Purchase = 2 Diamonds = Double Value Creation',
    centerBig: '5',
    centerCaption: 'Example: $10,000 purchase = $20,000 total value',
    cycle: [
      {
        n: '1.',
        title: 'Customer Purchase',
        body: 'Customer buys a diamond with processing time, e.g. $10,000.'
      },
      {
        n: '2.',
        title: 'Dual Assignment',
        body: 'Instant and simultaneous: 1 rough diamond for the customer — 100 % their property. 1 rough diamond for the company — financed from the profit.'
      },
      {
        n: '3.',
        title: 'Value Creation',
        body: 'Combined finished sale value of both diamonds: $20,000 — in the portfolio.'
      },
      {
        n: '4.',
        title: 'Active Trading',
        body: 'The company diamond is immediately processed and traded.'
      },
      {
        n: '5.',
        title: 'Further Revenue',
        body: 'Profits flow into mining licenses, the extraction of rough diamonds and the purchase — STIG Ethical Mines.'
      }
    ],
    steps: [
      { title: 'Mine', subtitle: 'Rough diamonds' },
      { title: 'Cutting', subtitle: 'through our partners' },
      { title: 'Certification', subtitle: 'through recognised institutes' },
      { title: 'End customers', subtitle: 'Purchase & discount credits' }
    ],
    footnote: 'Rough diamond: STIG Ethical Mines · Refinement to sale: STIG International Gemstone FZCO'
  },
  vip: {
    overline: 'STIG ROCK',
    title: 'Pakketti VIP',
    sub: 'Validu għal 12-il xahar fuq il-pjanijiet kollha Solution li s-sottoskrivijt. Skont il-pakkett VIP: +1% sa +3% skont addizzjonali',
    cardKicker: 'addizzjonali – fuq il-pjanijiet kollha',
    cardKicker2: 'STIG ROCK',
    packages: [
      { name: 'VIP 1', price: '$150', bonus: '+1%' },
      { name: 'VIP 2', price: '$500', bonus: '+2%' },
      { name: 'VIP 3', price: '$1.000', bonus: '+3%' }
    ],
    example: {
      title: 'L-iskontijiet isiru ffrankar',
      body: 'Iffrankar fix-xahar minflok piż fix-xahar. Mill-iskontijiet jiġi l-iffrankar — u dan iħallas preċiżament l-affarijiet li normalment tħallas għalihom kull xahar minn butek stess.',
      line1Label: 'DS-Plan minn',
      line1Value: '$5.000',
      line2Label: 'skont kull xahar',
      line2Value: '3%',
      line3Label: 'Pakkett VIP 3',
      line3Value: '+3%',
      resultLabel: 'iffrankar kull xahar',
      resultValue: '$300'
    }
  },
  wertschoepfung: {
    overline: 'Kif inhu possibbli dan?',
    title: 'Aħna biddilna l-mod kif naħsbu dwar il-katina tal-valur.',
    traditionalTitle: 'It-triq tradizzjonali',
    traditionalSteps: [
      'Minjiera — Diamond mhux maħduma',
      'Negozjant intermedju — Xiri',
      'Illustrar — Qtugħ',
      'Ċertifikazzjoni (GIA)',
      'Borża tad-Diamond — Bejgħ bl-ingrossa',
      'Bejgħ bl-ingrossa → Bejgħ bl-imnut',
      'Ġojjelliera → Klijent finali'
    ],
    traditionalNote: 'Qabel ma djamant jilħaq il-klijent finali, jinħolqu marġini kummerċjali sinifikanti permezz tal-kummerċ intermedju, bl-ingrossa u bl-imnut.',
    stigTitle: "It-triq ta' STIG ROCK",
    stigSteps: [
      'Xiri dirett — Diamond mhux maħduma mill-minjiera',
      'Illustrar u Ċertifikazzjoni mill-imsieħba tagħna',
      'Bejgħ lil klijenti finali u klijenti B2B',
      'Sa 4 ċikli kummerċjali fis-sena'
    ],
    stigNote: "Aħna nkissru ċ-ċiklu u ngħaddu l-marġini kummerċjali bħala krediti ta' skont lill-klijenti tagħna — sa 4 ċikli kummerċjali matul it-terminu tad-DS-Plan."
  },
  optionen: {
    overline: 'L-opportunitajiet tiegħek',
    title: 'Wara l-iskadenza tal-pjan Solution tiegħek',
    items: [
      {
        title: 'Ibgħathom id-dar',
        body: 'Diamond (Karat) għall-prezz tad-DS-Plan tiegħek.'
      },
      { title: 'Biegħ lilna', body: 'Bejgħ lura għall-prezz tax-xiri li ħallast.' },
      { title: 'Biegħ lil terzi', body: 'Ibigħ id-Diamond fis-suq ħieles.' }
    ]
  },
  einfacherWeg: {
    overline: 'Pjanijiet Solution — innovazzjoni unika tal-prodott',
    title: 'It-triq faċli',
    steps: [
      {
        n: '01',
        icon: 'signup',
        title: 'Reġistrazzjoni',
        body: "Ikkuntattja lill-persuna li rrakkomandatek u oħloq kont b'xejn!"
      },
      { n: '02', icon: 'cart', title: "Xiri ta' prodott", body: 'Minn $250 biss,-' },
      {
        n: '03',
        icon: 'discount',
        title: 'Irċievi skontijiet',
        body: "Irċievi krediti ta' skont kull xahar."
      }
    ]
  },
  business: {
    overline: "Tipi ta' bonus",
    title: 'L-aktar mod faċli u ġust.',
    sub: "Ħames tipi ta' bonus — għall-bini b'suċċess tan-negozju tiegħek.",
    bonuses: [
      {
        name: 'Unilevel Bonus',
        icon: 'unilevel',
        value: '18%',
        desc: 'Sa Level 3, mil-livell tal-karriera Pearl / Ruby.'
      },
      {
        name: 'Infinity Bonus',
        icon: 'infinity',
        value: '24%',
        desc: 'Minn Sapphire — fil-fond infinit.'
      },
      {
        name: 'Matching Bonus',
        icon: 'matching',
        value: '5%',
        desc: 'Fuq l-Infinity Bonus – sa Level 5 · MINGĦAJR kwalifika.'
      },
      {
        name: 'World Pools',
        icon: 'world',
        value: '3%',
        desc: '3 pools mill-bejgħ dinji.'
      },
      {
        name: 'Rang Bonus',
        icon: 'rank',
        value: '$8.325 Mio.',
        desc: "Bonus ta' darba f'Diamond (Karat)."
      }
    ]
  },
  unilevel: {
    overline: 'STIG ROCK · Unilevel Bonus',
    title: 'Unilevel Bonus',
    sub: "Dan il-bonus jitħallsek għal kull pjan ġdid ta' Solution sa Level 3. B'kwalifiki minimi ħafna, tiftaħ il-livelli individwali.",
    total: 'Sa 18% Unilevel Bonus',
    levels: [
      {
        level: 'Level 1',
        value: '10%',
        qual: 'mill-bidu nett',
        coin: 'image84.png',
        badge: 'Partner'
      },
      {
        level: 'Level 2',
        value: '5%',
        qual: 'mil-livell tal-karriera Pearl',
        coin: 'image83.png',
        badge: 'Pearl'
      },
      {
        level: 'Level 3',
        value: '3%',
        qual: 'mil-livell tal-karriera Ruby',
        coin: 'image85.png',
        badge: 'Ruby'
      }
    ]
  },
  infinity: {
    overline: 'STIG ROCK · Infinity Bonus',
    title: 'Infinity Bonus',
    sub: "Mil-livell tal-karriera Sapphire inti kkwalifikat għall-pjan ta' Infinity Bonus tagħna. Tirċievi 3% bonus. Ma' kull livell tal-karriera ġdid jiżdiedu aktar perċentwali. Jekk sieħeb fit-tim tiegħek ikun ikkwalifikat ukoll, tirċievi d-differenza minn grad għal grad.",
    exampleTitle: 'Eżempju',
    exampleRows: [
      { label: 'Inti Blue Diamond', value: '12%' },
      { label: 'Is-sieħeb tiegħek huwa Sapphire', value: '3%' }
    ],
    exampleResult: { label: 'L-Infinity Bonus tiegħek', value: '9%' },
    totalNote: 'Total sa 24% Infinity Bonus fuq il-pjanijiet kollha Solution sottoskritti fit-tim tiegħek — fil-fond infinit.',
    ranks: [
      { name: 'Sapphire', value: '3%', coin: 'image89.png' },
      { name: 'Emerald', value: '6%', coin: 'image90.png' },
      { name: 'Diamond', value: '9%', coin: 'image91.png' },
      { name: 'Blue Diamond', value: '12%', coin: 'image92.png' },
      { name: 'Green Diamond', value: '15%', coin: 'image93.png' },
      { name: 'Purple Diamond', value: '18%', coin: 'image94.png' },
      { name: 'Diamond Elite', value: '21%', coin: 'image96.png' },
      { name: 'Double Diamond Elite', value: '22%', coin: 'image97.png' },
      { name: 'Triple Diamond Elite', value: '23%', coin: 'image98.png' },
      { name: 'Black Diamond', value: '24%', coin: 'image99.png' }
    ]
  },
  matching: {
    overline: 'STIG ROCK · Matching Bonus',
    title: 'Matching Bonus',
    sub: "B'dan il-bonus inti tapprofitta mis-suċċess tat-tim tiegħek. Tirċievi Matching Bonus ta' 5% fuq l-Infinity Bonus tal-imsieħba tiegħek — u dan sa Level 5 fit-tim tiegħek.",
    note: 'Fuq il-pagamenti kollha tal-Infinity Bonus fit-tim tiegħek – sa Level 5. Mill-bidu nett – MINGĦAJR kwalifika.',
    levels: [
      { level: 'Level 1', value: '5%' },
      { level: 'Level 2', value: '5%' },
      { level: 'Level 3', value: '5%' },
      { level: 'Level 4', value: '5%' },
      { level: 'Level 5', value: '5%' }
    ],
    totalPrefix: 'Total sa',
    totalValue: '25%',
    totalSuffix: 'Matching Bonus'
  },
  worldPools: {
    overline: 'STIG ROCK · Worldpools',
    title: 'Worldpools',
    sub: "3% tal-bejgħ dinji jmorru f'partijiet ugwali fi 3 pools differenti. Billi tilħaq ċerti livelli tal-karriera, tikkwalifika għal kull pool individwali.",
    forever: 'Ladarba milħuq – tipparteċipa għal DEJJEM!',
    pools: [
      { key: 'p1', label: 'Pool 1', value: '1%', qual: 'minn Blue Diamond' },
      { key: 'p2', label: 'Pool 2', value: '1%', qual: 'minn Purple Diamond' },
      { key: 'p3', label: 'Pool 3', value: '1%', qual: 'minn Double Diamond Elite' }
    ],
    ranks: [
      { name: 'Blue Diamond', coin: 'image92.png', shares: [ 1, 0, 0 ] },
      { name: 'Green Diamond', coin: 'image93.png', shares: [ 2, 0, 0 ] },
      { name: 'Purple Diamond', coin: 'image94.png', shares: [ 2, 1, 0 ] },
      { name: 'Diamond Elite', coin: 'image96.png', shares: [ 2, 2, 0 ] },
      { name: 'Double Diamond Elite', coin: 'image97.png', shares: [ 2, 2, 1 ] },
      { name: 'Triple Diamond Elite', coin: 'image98.png', shares: [ 2, 2, 2 ] },
      { name: 'Black Diamond', coin: 'image99.png', shares: [ 2, 2, 3 ] }
    ],
    totalPrefix: 'Total',
    totalValue: '3%',
    totalSuffix: 'tal-bejgħ dinji'
  },
  rangBonus: {
    overline: 'STIG ROCK · Rang Bonus',
    title: 'Rang Bonus',
    sub: "Mil-livell tal-karriera Diamond tirċievi Rang Bonus. Dan jitħallas f'Diamond (Karat). Dan huwa bonus ta' darba.",
    highlight: "Diamond (Karat) b'valur totali ta'",
    totalValue: '$8.325.000',
    ranks: [
      { name: 'Emerald', coin: 'image90.png', value: '' },
      { name: 'Diamond', coin: 'image91.png', value: '$5.000' },
      { name: 'Blue Diamond', coin: 'image92.png', value: '$20.000' },
      { name: 'Green Diamond', coin: 'image93.png', value: '$50.000' },
      { name: 'Purple Diamond', coin: 'image94.png', value: '$100.000' },
      { name: 'Diamond Elite', coin: 'image96.png', value: '$150.000' },
      { name: 'Double Diamond Elite', coin: 'image97.png', value: '$1.000.000' },
      { name: 'Triple Diamond Elite', coin: 'image98.png', value: '$2.000.000' },
      { name: 'Black Diamond', coin: 'image99.png', value: '$5.000.000' }
    ]
  },
  karriere: {
    overline: 'STIG ROCK · Karrierestufen',
    title: 'Livelli tal-karriera',
    sub: "Biex jintlaħqu l-livelli rispettivi tal-karriera, jgħodd il-bejgħ totali storiku (HG). Mil-livell Sapphire, dan għandu jkun imqassam fuq bosta timijiet. Biex tilħaq Ruby jew ogħla, għandek bżonn tal-inqas żewġ imsieħba diretti b'DS-Plan.",
    forever: 'Ladarba milħuq – ikkonfermat għal DEJJEM!',
    footnote: 'HV = Historisches Volumen (Bejgħ totali storiku).',
    ranks: [
      { name: 'Partner', coin: 'image84.png', hg: '', perks: [ '1 Unilevel' ] },
      { name: 'Pearl', coin: 'image83.png', hg: '250 HV', perks: [ '2 Unilevels' ] },
      {
        name: 'Ruby',
        coin: 'image85.png',
        hg: '500 HV',
        perks: [ '2 dir. Pearl', '3 Unilevels' ]
      },
      {
        name: 'Sapphire',
        coin: 'image89.png',
        hg: '25.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 3%' ]
      },
      {
        name: 'Emerald',
        coin: 'image90.png',
        hg: '50.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 6%' ]
      },
      {
        name: 'Diamond',
        coin: 'image91.png',
        hg: '250.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 9%', '$5k Bonus' ]
      },
      {
        name: 'Blue Diamond',
        coin: 'image92.png',
        hg: '1.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 12%', '$20k Bonus', '1 Pool' ]
      },
      {
        name: 'Green Diamond',
        coin: 'image93.png',
        hg: '2.500.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 15%', '$50k Bonus', '1 Pool' ]
      },
      {
        name: 'Purple Diamond',
        coin: 'image94.png',
        hg: '5.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 18%', '$100k Bonus', '2 Pools' ]
      },
      {
        name: 'Diamond Elite',
        coin: 'image96.png',
        hg: '10.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 21%', '$150k Bonus', '2 Pools' ]
      },
      {
        name: 'Double Diamond Elite',
        coin: 'image97.png',
        hg: '50.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 22%', '$1M Bonus', '3 Pools' ]
      },
      {
        name: 'Triple Diamond Elite',
        coin: 'image98.png',
        hg: '150.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 23%', '$2M Bonus', '3 Pools' ]
      },
      {
        name: 'Black Diamond',
        coin: 'image99.png',
        hg: '500.000.000 HV*',
        perks: [ '3 Unilevels', 'Infinity 24%', '$5M Bonus', '3 Pools' ]
      }
    ]
  },
  cta: {
    overline: 'Ibda s-suċċess magħna',
    title: 'Il-ħin it-tajjeb huwa preċiżament issa.',
    body: "Dan il-mudell tan-negozju jistabbilixxi standards ġodda u jgħaqqad il-fatturi kollha ta' suċċess għal negozju sostenibbli u b'suċċess fit-tul. Irreġistra llum, agħżel il-pjan Solution tiegħek u uża din l-opportunità unika tan-negozju.",
    hint: 'Kellem lill-persuna li stedintek għal din il-preżentazzjoni — hija għandha link tar-reġistrazzjoni għalik.',
    formName: 'Isem',
    formEmail: 'E-Mail',
    formPhone: 'Telefon',
    formSubmit: 'Agħmel kuntatt',
    success: "Grazzi ħafna — se nikkuntattjawk b'mod diskret u personali.",
    callCta: 'Ċempel',
    whatsapp: 'WhatsApp'
  },
  footer: {
    disclaimerTitle: 'Avviż Legali u Disclaimer',
    disclaimer: "Din il-preżentazzjoni hija għal skopijiet ta' informazzjoni biss u ma tikkostitwixxix parir finanzjarju, ta' investiment jew tat-taxxa. STIG ROCK mhuwiex prodott finanzjarju, iżda jirreferi għal djamanti naturali bħala assi tanġibbli. Ma tingħata l-ebda garanzija għal żviluppi fil-valur, profitti jew qligħ. Żviluppi tal-passat mhumiex indikazzjoni ta' riżultati futuri. Il-kalkoli kollha ppreżentati fir-rigward tal-kummissjonijiet huma biss eżemplari u bl-istess mod ma jikkostitwixxu l-ebda garanzija. Riżervati l-bidliet fil-kontenut — traduzzjoni ħielsa (mhux traduzzjoni uffiċjali).",
    hq: 'HDS Business Centre — Jumeirah Lakes Towers — Dubai, VAE',
    copy: '© 2026 STIG International. Id-drittijiet kollha riżervati.',
    version: 'Verżjoni: DS-12-2025 V3'
  },
  misc: { next: 'Sezzjoni li jmiss' }
};

export default mt;
